<script>
  /* global Global */
  export let value;
  export let link;
  export let icon = undefined;
  export let color = undefined;
  export let dark = false;
  export let admin = false;
  export let disabled = false;
  export let cssClass = undefined;

  if (disabled) link = undefined;

  const projectStyle = Global.project.style;
</script>

<a href={link} class='button-link {cssClass || ''}' class:button-link-old={projectStyle === 'old' || projectStyle === 'sharp'}
  class:button-link-red={color === 'red'}
  class:button-link-yellow={color === 'yellow'}
  class:button-link-green={color === 'green'}
  class:button-link-blue={color === 'blue'}
  class:button-link-dark={dark}
  class:button-link-admin={admin}
  class:button-link-disabled={disabled}>

  <div class='button-link-box'>
    <div class='button-link-box-text'>
      {#if icon} <span class='material-icons'> {icon} </span> {/if} {value}
    </div>
  </div>
</a>

<style>
  .button-link {
    width: 100%;
    height: 40px;

    border-radius: var(--radius-lg);

    text-decoration: none;

    color: inherit;
    background: var(--grey-1);

    user-select: none;
  }

  .button-link-box {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;

    border-radius: var(--radius-lg);

    transition: background-color 0.25s ease-in-out;
  }

  .button-link:not(.button-link-disabled):hover .button-link-box {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .button-link:not(.button-link-disabled):active .button-link-box {
    background-color: rgba(0, 0, 0, 0.2);
  }

  .button-link-red {
    background: linear-gradient(135deg, var(--red), var(--dark-red));
    color: var(--white);
  }

  .button-link-old.button-link-red {
    background: var(--red);
  }

  .button-link-yellow {
    background: linear-gradient(135deg, var(--yellow), var(--orange));
    color: var(--white);
  }

  .button-link-old.button-link-yellow {
    background: var(--yellow);
  }

  .button-link-green {
    background: linear-gradient(135deg, var(--green), var(--dark-green));
    color: var(--white);
  }

  .button-link-old.button-link-green {
    background: var(--green);
  }

  .button-link-blue {
    background: linear-gradient(135deg, var(--blue), var(--dark-blue));
    color: var(--white);
  }

  .button-link-old.button-link-blue {
    background: var(--blue);
  }

  .button-link-dark {
    background: var(--grey-3);
  }

  .button-link-admin {
    font-family: 'JetBrains Mono';
    font-weight: bold;
  }

  .button-link-disabled {
    cursor: not-allowed;

    opacity: 0.5;
  }

  :global(body.dark) .button-link {
    background: var(--grey-8);
    color: var(--grey-3);
  }

  :global(body.dark) .button-link:not(.button-link-disabled):hover .button-link-box {
    background-color: rgba(255, 255, 255, 0.1);
  }

  :global(body.dark) .button-link:not(.button-link-disabled):active .button-link-box {
    background-color: rgba(255, 255, 255, 0.2);
  }

  :global(body.dark) .button-link-red {
    background: linear-gradient(135deg, var(--red-dark), var(--dark-red-dark));
  }

  :global(body.dark) .button-link-old.button-link-red {
    background: var(--red-dark);
  }

  :global(body.dark) .button-link-yellow {
    background: linear-gradient(135deg, var(--yellow-dark), var(--orange-dark));
  }

  :global(body.dark) .button-link-old.button-link-yellow {
    background: var(--yellow-dark);
  }

  :global(body.dark) .button-link-green {
    background: linear-gradient(135deg, var(--green-dark), var(--dark-green-dark));
  }

  :global(body.dark) .button-link-old.button-link-green {
    background: var(--green-dark);
  }

  :global(body.dark) .button-link-blue {
    background: linear-gradient(135deg, var(--blue-dark), var(--dark-blue-dark));
  }

  :global(body.dark) .button-link-old.button-link-blue {
    background: var(--blue-dark);
  }

  :global(body.dark) .button-link-dark {
    background: var(--grey-7);
  }
</style>
